import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ChartOptions } from 'services/models/charts/ChartOptions';
import { FormMetricsItemModel } from 'services/models/form-builder/form-metrics/form-metrics-item.model';
import { FormMetricsChartMapperService } from '../../services/form-metrics-chart-mapper.service';

@Component({
  selector: 'app-form-metrics-temporal-widget',
  templateUrl: './form-metrics-temporal-widget.component.html',
  styleUrls: ['./form-metrics-temporal-widget.component.scss'],
})
export class FormMetricsTemporalWidgetComponent implements OnChanges {
  @Input() item: FormMetricsItemModel;

  chartOptions: Partial<ChartOptions> | null = null;

  constructor(private chartMapper: FormMetricsChartMapperService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['item'] && this.item) {
      this.chartOptions = this.item.totalAnswers > 0 ? this.chartMapper.mapTemporal(this.item) : null;
    }
  }
}
